export default __webpack_public_path__ + "static/media/HamburgerLogo.50fa7a53.svg";